import { Box } from "@mui/material";
import React from "react";
import Section from "../../../../components/section/section";
import IDayliPlan from "../interface/iDayliPlan";
import RenderApoointment from "./renderApoointment";
import IDayliPlanAppointment from "../interface/iDayliPlanAppointment";
import { DayliPlanContext } from "../context/dayliPlanContext";
import LoadMoreButton from "./loadMoreButton";
import FileDialog from "./fileDialog";

const AppointmentList = (): React.JSX.Element => {
  const {
    dayliPlan,
    maxShownAppointments,
  }: {
    dayliPlan: IDayliPlan;
    maxShownAppointments: number;
  } = React.useContext(DayliPlanContext);

  return (
    <Section>
      {dayliPlan.appointments
        .slice(0, maxShownAppointments)
        .map((appointment: IDayliPlanAppointment) => (
          <Box key={appointment.id}>
            <RenderApoointment appointment={appointment} />
          </Box>
        ))}

      <LoadMoreButton />
      <FileDialog />
    </Section>
  );
};

export default AppointmentList;
